import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';

import { ReplaySubject } from 'rxjs/ReplaySubject';
import { CachedDataService } from '@services/data/cached-data.service';
import { Observable } from 'rxjs/Observable';
import { DeviceState } from '@models/device-state';
import { BaseHttpService } from '@services/http/base-http.service';
import { Router } from '@angular/router';
import { AuthService } from '@services/http/auth.service';

import { ShareRequest } from "@models";


/*Eenvironment */
import { environment } from '@environments';

@Injectable()
export class ShareDeviceService extends BaseHttpService {

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService) {
    super(httpClient, cachedDataService, router, authService);
  }

  updateRequestsSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
  updateRequestsObservable = this.updateRequestsSubject.asObservable();

  shareDevice(userName: string, deviceId: string, permissions: string): Observable<any> {
    const body: object = {
        userName: userName,
        deviceId: deviceId,
        permissions: permissions
    };
    
    return super.send('POST', environment.apiUri +'deviceSharing/request', null, true, body);
  }
  getShareDevice(): Observable<Array<ShareRequest>> { 
    return super.send('GET', environment.apiUri +'deviceSharing/request', null, true, null);
  }
  confirmShareDevice(DeviceId: string, SlaveUserId: string,Status?:string, Permissions?:string,ObservableObjectId?:string): Observable<Array<any>> { 

    let body = {
      DeviceId: DeviceId,
      SlaveUserId: SlaveUserId
    }
    if(Permissions!=undefined){
      body["Permissions"] = Permissions;
    }
    if(ObservableObjectId!=undefined){
      body["ObservableObjectId"] = ObservableObjectId;
    }
    if(Status!=undefined){
      body["Status"] = Status;
    }
    return super.send('PUT', environment.apiUri +'deviceSharing/request', null, true, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/share-device.service.ts